var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55.136,
    viewBox: "0 0 55 55.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contact_pinterest",
    d: "M27.569,0A27.537,27.537,0,0,0,17.53,53.181a26.474,26.474,0,0,1,.094-7.9c.5-2.153,3.23-13.685,3.23-13.685a9.965,9.965,0,0,1-.825-4.092c0-3.82,2.222-6.687,4.981-6.687,2.352,0,3.487,1.767,3.487,3.878,0,2.364-1.5,5.9-2.279,9.171A4,4,0,0,0,30.3,38.838c4.889,0,8.656-5.157,8.656-12.605,0-6.573-4.739-11.186-11.5-11.186-7.834,0-12.426,5.886-12.426,11.944a10.723,10.723,0,0,0,2.042,6.3.84.84,0,0,1,.2.793c-.207.861-.673,2.754-.767,3.131-.122.517-.4.623-.921.379-3.434-1.585-5.589-6.612-5.589-10.673,0-8.675,6.313-16.66,18.195-16.66,9.552,0,16.982,6.816,16.982,15.9,0,9.5-5.989,17.143-14.319,17.143-2.789,0-5.408-1.445-6.336-3.168l-1.721,6.543a30,30,0,0,1-3.441,7.227A27.54,27.54,0,1,0,27.5.06Z",
    transform: "translate(-0.029)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPinterest);
export default __webpack_public_path__ + "static/media/contact_pinterest.9693b03a958d9cf74bdd3b5f17d01a55.svg";
export { ForwardRef as ReactComponent };